var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useGoogleLogin } from '@react-oauth/google';
import { Form } from 'antd';
import { useEffect, useState } from 'react';
import { FORM_STEPS_KEYS, FORM_TYPES_KEYS } from '../../constants/Auth';
export var useSignIn = function () {
    var form = Form.useForm()[0];
    var _a = useState({ radio: '' }), formData = _a[0], setFormData = _a[1];
    var _b = useState(false), touched = _b[0], setTouched = _b[1];
    var _c = useState(0), currentStep = _c[0], setCurrentStep = _c[1];
    var _d = useState(false), isLastStep = _d[0], setIsLastStep = _d[1];
    var _e = useState(''), authType = _e[0], setAuthType = _e[1];
    useEffect(function () {
        var _a;
        var stepsMapping = (_a = {},
            _a[FORM_TYPES_KEYS.GOOGLE] = [FORM_STEPS_KEYS.TYPE_SELECT_FIELDS],
            _a[FORM_TYPES_KEYS.UNI_ACCOUNT] = [FORM_STEPS_KEYS.TYPE_SELECT_FIELDS],
            _a[FORM_TYPES_KEYS.EMAIL] = [FORM_STEPS_KEYS.TYPE_SELECT_FIELDS, FORM_STEPS_KEYS.MAIN_FIELDS],
            _a);
        var updatedSteps = stepsMapping[authType] || [];
        setIsLastStep(currentStep === updatedSteps.length - 1);
    }, [currentStep, authType]);
    var onNext = function () {
        form.validateFields().then(function (values) {
            var updatedFormData = __assign(__assign({}, formData), values);
            setFormData(updatedFormData);
            if (isLastStep) {
                submit(updatedFormData);
            }
            else {
                setCurrentStep(function (prevStep) { return prevStep + 1; });
            }
        });
    };
    var onBack = function () {
        var newStep = Math.max(0, currentStep - 1);
        setCurrentStep(newStep);
    };
    var submit = function (values) {
        if (values.radio === FORM_TYPES_KEYS.GOOGLE) {
            onGoogleLogin();
        }
        else if (values.radio === FORM_TYPES_KEYS.UNI_ACCOUNT) {
            console.log('sso', values);
        }
        else {
            console.log('email', values);
        }
    };
    var onGoogleLogin = useGoogleLogin({
        onSuccess: function (tokenResponse) {
            console.log(tokenResponse);
        },
    });
    return {
        form: form,
        currentStep: currentStep,
        touched: touched,
        setTouched: setTouched,
        onNext: onNext,
        isLastStep: isLastStep,
        formData: formData,
        authType: authType,
        setAuthType: setAuthType,
        onBack: onBack
    };
};
